export default import.meta.ROLLDOWN_FILE_URL_Z7aa8YZZmLrMI4USVJZnAw